export const PARAMETER_ROWS = 'PARAMETER_ROWS';
export const PARAMETER_COLUMNS = 'PARAMETER_COLUMNS';

export const PARAMETER_WIDTH = 'PARAMETER_WIDTH';
export const UNDO_WIDTH = 'UNDO_WIDTH';
export const PARAMETER_LENGTH = 'PARAMETER_LENGTH';
export const UNDO_LENGTH = 'UNDO_LENGTH';
export const PARAMETER_DIMENSIONS = 'PARAMETER_DIMENSIONS';
export const PARAMETER_BIKE_COUNT = 'PARAMETER_BIKE_COUNT';
export const PARAMETER_CONFIGURATION = 'PARAMETER_CONFIGURATION';
export const PARAMETER_RACK = 'PARAMETER_RACK';

export const RENDER_BIKES = 'RENDER_BIKES';

export const REFERENCE_POINTS = 'REFERENCE_POINTS';

export const MOUSE_OVER_DASHBOARD = 'MOUSE_OVER_DASHBOARD';

export const SAVE_PDF_ON = 'SAVE_PDF_ON';
export const SAVE_PDF_OFF = 'SAVE_PDF_OFF';

export const SWITCH_UX_PATH = 'SWITCH_UX_PATH';

export const CONFIGURATION_RESULTS = 'CONFIGURATION_RESULTS';



// WEBPACK FOOTER //
// ./src/config/constants.js